import React from 'react';

import { connect } from 'react-redux';

import { ensureSubscriptionData } from 'utils';

import PopupHandle from './popupHandle';
import AmbientAudio from '../audio';
import HandleAutoRotate from './handleAutoRotate';

import './style.scss';
import { TitleFollowCursor } from 'components/TitleFollowCursor';
import MouseGuideline from 'components/MouseGuideline';
import CedoraLayout from 'components/CedoraLayout/index.jsx';

const World2D = (props) => {
  const {
    json,
    currentPano,
    autoRotate,
    showSpinner,
    showIntro,
    hotspotHistory,
    shouldRotate,
    selectSceneById,
  } = props;

  return (
    <div className={`World-2D-Contents`}>
      <CedoraLayout
        menuList={json.menu}
        scenes={json.scenes}
        groups={json.groups}
        currentPano={currentPano}
        autoRotate={autoRotate}
        shouldRotate={shouldRotate}
        showSpinner={showSpinner}
        toggleRotate={props.toggleRotate}
        toggleFeatured={props.toggleFeatured}
        onSelectScene={props.selectSceneById}
        toggleMap={props.toggleMap}
        // subTitle={location}
        control={props.control}
        switchControl={props.switchControl}
        showLanding={props.onClickPoweredBy}
      />
      <TitleFollowCursor />

      <HandleAutoRotate
        autoRotate={autoRotate}
        shouldRotate={shouldRotate}
        scenes={json.scenes}
        currentPano={currentPano}
        onChangeScene={props.selectSceneById}
      />

      <PopupHandle
        mediasList={json.media}
        mediaGroups={json.mediaGroups}
        menuList={json.menu}
        tour={json.tour}
        scenes={json.scenes}
        hotspotHistory={hotspotHistory}
        history={props.history}
        currentPano={currentPano}
        selectSceneById={selectSceneById}
      />
      {currentPano && (
        <>
          <AmbientAudio
            scene={currentPano}
            spinnerOn={showSpinner}
            introOn={showIntro}
          />
          <MouseGuideline />
        </>
      )}
    </div>
  );
};

const mapStateToProps = (store) => ({
  json: store.json || {},
  currentHotspot: store.currentHotspot,
  mapPopupOpen: store.menu.isoMetricMap,
  socialPopupOpen: store.menu.social,
  tour: store.json.tour || null,
  scope: ensureSubscriptionData(store.tour.subscriptionPlan.scopes),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(World2D);
